// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1zF-Y","column":"style_column__3EC4Y"};